module.exports = __webpack_public_path__ + "static/media/statement.5bbe507b.svg";